import React, { useState } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Drawer from './components/Drawer';
import Home from './pages/Home';
import WorkWithUs from './pages/WorkWithUs';
import Talent from './pages/Talent';
import Brands from './pages/Brands';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
// Network Pages
import NetworkAuth from './pages/network/NetworkAuth';
import NetworkComingSoon from './pages/network/NetworkAuth.coming-soon';
import BrandDashboard from './pages/network/BrandDashboard';
import InfluencerDashboard from './pages/network/InfluencerDashboard';
import PostJob from './pages/network/PostJob';
import JobDetail from './pages/network/JobDetail';
import InfluencerProfile from './pages/network/InfluencerProfile';
import ResetPassword from './pages/network/ResetPassword';
import AgentConsole from './pages/network/AgentConsole';
import './App.css';

const NETWORK_COMING_SOON = false;

function App() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const location = useLocation();
  
  // Check if user is authenticated (has token) - check synchronously on every render
  const isAuthenticated = !!localStorage.getItem('token');
  
  // Hide header on network pages (they have their own navigation)
  const isNetworkPage = location.pathname.startsWith('/network');
  
  // Show full network if Coming Soon is off OR user is authenticated
  const showFullNetwork = !NETWORK_COMING_SOON || isAuthenticated;

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <div className="app">
      {!isNetworkPage && (
        <>
          <Header isDrawerOpen={isDrawerOpen} toggleDrawer={toggleDrawer} />
          <Drawer isOpen={isDrawerOpen} onClose={closeDrawer} />
        </>
      )}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/work-with-us" element={<WorkWithUs />} />
          <Route path="/talent" element={<Talent />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/contact" element={<Contact />} />
          {/* Public legal pages (always accessible) */}
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          {/* Password reset is always reachable (via emailed link) */}
          <Route path="/network/reset-password" element={<ResetPassword />} />
          {/* Network Routes */}
          {showFullNetwork ? (
            <>
              {/* Full Network Mode - shown when not coming soon OR user is authenticated */}
              <Route path="/network" element={<NetworkAuth />} />
              <Route path="/network/brand-dashboard" element={<BrandDashboard />} />
              <Route path="/network/influencer-dashboard" element={<InfluencerDashboard />} />
              <Route path="/network/post-job" element={<PostJob />} />
              <Route path="/network/edit-job/:jobId" element={<PostJob />} />
              <Route path="/network/job/:jobId" element={<JobDetail />} />
              <Route path="/network/influencer-profile" element={<InfluencerProfile />} />
              <Route path="/network/agent" element={<AgentConsole />} />
            </>
          ) : (
            <>
              {/* Coming Soon Mode - all network routes show coming soon page */}
              <Route path="/network" element={<NetworkComingSoon />} />
              <Route path="/network/*" element={<Navigate to="/network" replace />} />
            </>
          )}
        </Routes>
      </main>
    </div>
  );
}

export default App;



